import React, { useState, useEffect } from "react";
import Toolbar from "@material-ui/core/Toolbar";
import Grid from "@material-ui/core/Grid";
import { PrimaryButton, SecondaryButton } from "@prestosports/commons-ui";
import Box from "@material-ui/core/Box";
import { useFootballContext } from "../../../../state/football-play/context";
import EventTimePicker from "../EventTimePicker";
import FormMessages from "../../../errors/components/FormMessages";
import SubmitCancelListener from "../listeners/SubmitCancelListener";

const TimeSelector = ({
	disableKeyListener,
	period,
	seconds,
	onSelected,
	hideCancel,
	editingPlay = false
}) => {
	const { startOver } = useFootballContext();

	const [totalSeconds, setTotalSeconds] = useState(seconds);
	const [errors, setErrors] = useState({});

	const confirm = () => {
		onSelected({
			milliseconds: totalSeconds * 1000,
			period
		});
	};

	const hasErrors = () => {
		return !!Object.keys(errors).length;
	};

	useEffect(() => {
		if (!hasErrors() && editingPlay) {
			confirm();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [totalSeconds, editingPlay]);

	return (
		<>
			{hasErrors() && (
				<Box pt={2} pb={2}>
					<FormMessages messages={errors} />
				</Box>
			)}
			<Box display="flex" justifyContent="center">
				<EventTimePicker
					period={period}
					seconds={seconds}
					onChange={setTotalSeconds}
					hideErrors
					onValidate={(isValid, _errors) => {
						setErrors(_errors);
					}}
				/>
			</Box>
			{!editingPlay && (
				<Toolbar disableGutters>
					<Grid
						container
						direction="row"
						justifyContent="flex-end"
						alignItems="center"
						spacing={1}
					>
						{!hideCancel && (
							<Grid item>
								<SecondaryButton
									onClick={startOver}
									variant="contained"
									label="Cancel"
								/>
							</Grid>
						)}
						<Grid item>
							<PrimaryButton onClick={confirm} label="Save" disabled={hasErrors()} />
						</Grid>
					</Grid>
				</Toolbar>
			)}
			{!disableKeyListener && (
				<SubmitCancelListener
					submitDisabled={hasErrors()}
					onSubmit={confirm}
					onCancel={startOver}
				/>
			)}
		</>
	);
};

export default TimeSelector;
